import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { formatNumber } from "../helpers/NumberFormats";
import { createSlug } from "../helpers/SlugHelper";

export interface GoatListItemProps {
  category_label: string;
  category_id: string;
  id: string;
  index: number;
  total_points?: number | string;
  average_rank?: number | string;
  number_of_lists?: number | string;
  image?: string;
  highlightFirst?: boolean;
  hash?: string;
  categoryName?: string; // Add category name to determine if it's rappers
}

const GoatListItem = (props: GoatListItemProps) => {
  const [bgColor, setBgColor] = React.useState("bg-transparent");

  // Determine if this should link to a rapper profile
  const isRapper = props.categoryName === "Rappers";
  const rapperProfileLink = `/rapper/${createSlug(props.category_label)}`;

  useEffect(() => {
    if (props.index === 0 && props.highlightFirst !== false) {
      setBgColor("bg-green-950");
    }
  }, [props.index]);

  useEffect(() => {
    if (props.hash === `#${props.id}`) {
      setBgColor("bg-green-950");
    } else {
      if (props.index !== 0 && !props.highlightFirst) {
        setBgColor("bg-transparent");
      }
    }
  }, [props.hash]);

  return (
    <li
      id={props.id}
      key={props.index}
      className={`item-container  ${bgColor}`}
    >
      <div className="flex h-32">
        <div className="relative flex-shrink-0 w-32 h-32">
          <Link to={rapperProfileLink}>
            <img
              alt={props.category_label}
              src={`${props.image}`}
              className="w-full h-full object-cover"
            />
          </Link>
          <div className="absolute top-2 left-2 w-8 h-8 bg-yellow-500 text-black font-bold text-md rounded-full flex items-center justify-center shadow-md shadow-black/50">
            #{props.index + 1}
          </div>
        </div>
        <div className="min-w-0 p-2">
          <p className="text-sm font-semibold leading-6">
            <Link
              to={rapperProfileLink}
              className={isRapper ? "hover:text-blue-400 text-lg" : "text-lg"}
            >
              {props.category_label}
            </Link>
            {isRapper && (
              <span className="ml-2 text-xs bg-blue-600 text-white px-2 py-1 rounded-full">
                Profile
              </span>
            )}
          </p>
          <p className="mt-0.5 truncate text-xs leading-5 text-gray-500 hover:text-black">
            {`Points: ${formatNumber(props.total_points)} | `}
            {`Avg Rank: ${props.average_rank}`}
            {/* {`${formatNumber(props.number_of_lists)} Lists`} */}
          </p>
        </div>
      </div>
    </li>
  );
};

export default GoatListItem;
